import { render, staticRenderFns } from "./publicAddress.vue?vue&type=template&id=b4e6d300&scoped=true&"
import script from "./publicAddress.vue?vue&type=script&lang=js&"
export * from "./publicAddress.vue?vue&type=script&lang=js&"
import style0 from "./publicAddress.vue?vue&type=style&index=0&id=b4e6d300&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e6d300",
  null
  
)

export default component.exports